<template>
    <div class="add-box">
        <div class="add-btn" v-if="list || (itemType == 'object'?(itemObj && Object.keys(itemObj).length === 0):itemArray.length === 0)" @click="add">
            {{title}}
        </div>
        <div class="list-box" v-else>
            <div class="left-scroll">
                <div style="display:flex">
                    <slot name="list"></slot>
                </div>
            </div>
            <div class="adds" @click="add" v-show="showBtn">
                <div>
                    <img src="../assets/img/mob_add_scene.png"/>
                    <h5>{{smTitle == '' ? title : smTitle}}</h5>
                </div>
            </div>
            <!-- <div class="add-new" @click="add" v-show="showBtn">
              <div class="text">{{$t('edit.ruler.addRuler').slice(0,2)}}</div>
              <div class="text">{{$t('edit.ruler.addRuler').slice(-2)}}</div>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "AddDrawer",
        props:{
            itemObj:{
                type: Object,
                default: ()=>{}
            },
            itemArray:{
                type:Array,
                default:()=>[]
            },
            title:{
                type: String,
                default: ''
            },
            smTitle:{
                type: String,
                default: ''
            },
            list:{
                type: Boolean,
                default: false
            },
            showBtn:{
                type: Boolean,
                default: true
            },
            itemType:{
                type: String,
                default:'object'
            }
        },
        methods:{
            add(){
                this.$emit('add')
            }
        }
    }
</script>

<style lang="less" scoped>
    .add-box{
        background-color: rgba(51, 51, 51, 1);//20
        padding: 0 16px;
        min-height: 80px;
        display: flex;
        // padding-left: 10px;
        .add-btn{
            margin: 22px 20px;
            height: 40px;
            flex: 1;
            background-color: #015c61;
            color: #ffffff;
            border-radius: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
        }
        .list-box{
            flex:1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            .left-scroll{
                flex: 1;
                width: 0;
                overflow-y: hidden;
                overflow-x: auto;
                display: flex;
                justify-content: flex-start;
                &::-webkit-scrollbar {
                    display: none;
                }
            }
            .adds{
                flex-shrink: 0;
                padding: 0 0 0 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                &>div{
                    text-align: center;
                }
                h5{
                    color: #f2f2f2;
                    margin: 2px 0 0 0;
                }
                img{
                    width: 22px;
                    height: 22px;
                }
            }
            // .add-new {
            //     width: 47px;
            //     height: 47px;
            //     color: white;
            //     color: rgba(255, 255, 255, 1);
            //     background-color: rgba(0, 0, 0, .1);
            //     border: 1px dashed rgba(255,255,255,.1);
            //     text-align: center;
            //     font-size: 12px;
            //     border-radius: 4px;
            //     display: flex;
            //     flex-direction: column;
            //     justify-content: center;
            // }
        }
    }
</style>
